import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "walletBalance",
    "submitButton",
    "selectAll",
    "checkbox",
    "kycStatus",
  ];

  connect() {
    this.updateTotalAndButtonState();
  }

  updateTotalAndButtonState() {
    const walletBalance = parseFloat(this.walletBalanceTarget.dataset.amount);
    const kycStatus = this.kycStatusTarget.dataset.status;

    let total = 0;
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        total += parseFloat(checkbox.dataset.amount) || 0;
      }
    });

    const shouldDisable = total > walletBalance || kycStatus !== "APPROVED";
    this.submitButtonTarget.disabled = shouldDisable;
  }

  toggleAll(event) {
    const checked = event.target.checked;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
    this.updateTotalAndButtonState();
  }

  toggleSingle() {
    const allChecked = this.checkboxTargets.every(
      (checkbox) => checkbox.checked
    );
    this.selectAllTarget.checked = allChecked;
    this.updateTotalAndButtonState();
  }
}
